require('./mortgageRequestSimpleNotePaymentView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { get, chain } = require('lodash');
const { withRouter } = require('react-router-dom');

// @ helpers
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;

// @ utilities
const { shouldGoToEstatesListPage } = require('utilities/mortgageHelper');

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const MortgageRequestSimpleNoteConstructions = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteConstructions/mortgageRequestSimpleNoteConstructions');
const MortgageRequestSimpleNoteAddress = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteAddressFormat/mortgageRequestSimpleNoteAddressFormat');
const MortgageRequestSimpleNoteRequestCostWafer = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteRequestCostWafer/mortgageRequestSimpleNoteRequestCostWafer');
const MortgageRequestErrorCustom = require('components/mortgageRequest/mortgageRequestErrorCustom/mortgageRequestErrorCustom');

// @ actions
const estatesAction = require('actions/mortgageRequest/mortgageRequestInmuebles');
const paymentAction = require('actions/mortgageRequest/mortgageRequestPayment');

// @constant
const { ESTATES_TYPE } = require('constants/mortgageRequestHolderData');
const { DATOS_VIV, PROBLEMA_NS } = require('constants/mortgageRequestStates');

const URLS = {
    PANEL: '/myprofile/mortgage/panel',
};

class MortgageRequestSimpleNotePaymentView extends React.Component {
    constructor(props) {
        super(props);
        this.buildLivingPlaceEstateWrapper = this.buildLivingPlaceEstateWrapper.bind(this);
        this.buildUdifirWrapper = this.buildUdifirWrapper.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { requestPayment, immEstates, history } = this.props;

        shouldGoToEstatesListPage(immEstates, history);
        requestPayment();
    }

    getMappingBreacrumb() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        return [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestSimpleNote-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);
    }



    buildIncludedEstates(garages, storageRooms) {
        const garagesText = garages && garages > 0 && `${garages} ${formatText('mortgageRequestSimpleNoteRequest-step1Garages')}`;
        const storageRoomsText = storageRooms && storageRooms > 0 && `${storageRooms} ${formatText('mortgageRequestSimpleNoteRequest-step1StorageRoom')}`;

        let includedEstatesHtml;
        if (garagesText && storageRoomsText) {
            includedEstatesHtml = (
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Includes', [storageRoomsText, garagesText])}
                </p>
            );
        } else if (garagesText) {
            includedEstatesHtml = (
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Include', [garagesText])}
                </p>
            );
        } else if (storageRoomsText) {
            includedEstatesHtml = (
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Include', [storageRoomsText])}
                </p>
            );
        }

        return includedEstatesHtml;
    }

    handleContinueButton() {
        this.props.history.push('/myprofile/mortgage/simple-note-payment');
    }

    handleOnCancelAddSimpleNote(evt) {
        evt.preventDefault();

        this.props.history.push(URLS.PANEL);
    }

    buildLivingPlaceEstateWrapper(item) {
        const udifir = get(item, 'udifir', '');
        const storageRooms = get(item, 'storageRooms', '');
        const garages = get(item, 'garages', '');
        const udifirWrapper = this.buildUdifirWrapper(udifir);
        const includedEstatesWrapper = this.buildIncludedEstates(garages, storageRooms);

        return (
            <div>
                <MortgageRequestSimpleNoteAddress
                    completeItem={item}
                />

                {udifirWrapper}

                {includedEstatesWrapper}
            </div>
        );
    }

    buildUdifirWrapper(udifir) {
        return udifir && (
            <div>
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Code')}
                </p>

                <p className="mortgage-request-simple-note-request-step-one__label">
                    {udifir}
                </p>
            </div>
        );
    }

    render() {
        const {
            immEstates,
            immPayment,
            immGlobalPosition,
            mortgageRequestState,
            summaryDocumentation,
        } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const estatesListData = immEstates.get('list');
        const simpleNoteCost = immPayment.get('simpleNoteCost');
        const item = chain(estatesListData.toJS()).filter(estate =>
            estate.tipoBien === ESTATES_TYPE.VIVIENDA && !(estate.notaSimplePropia)).last().value();
        const livingPlaceState = item ? this.buildLivingPlaceEstateWrapper(item) : null
        const otherEstatesTitle = item ? true : false
        const currentState = mortgageRequestState.get('estado');

        let content;
        if ((currentState !== DATOS_VIV && currentState !== PROBLEMA_NS) || immEstates.get('list').isEmpty()) {
            content = (
                <MortgageRequestErrorCustom
                    errorTitle={formatText('mortgageRequestSimpleNoteError-title')}
                    goBackButtonLabel={formatText('mortgageRequestSimpleNoteError-goBackLink')}
                    goBackButtonLink={'/myprofile/mortgage/panel'}
                >
                    <div className="mortgage-request-simple-note-error__text">
                        <p>{formatText('mortgageRequestSimpleNoteError-message')}</p>
                    </div>
                </MortgageRequestErrorCustom>
            )
        } else {
            content = (
                <ContentBox>
                    <OKBoxTitle
                        value={formatText('mortgageRequestSimpleNote-subtitleNoClient')}
                        size="medium"
                    />
                    <div className="mortgage-request-simple-note-payment-view__body-block-1">
                        <div>
                            {livingPlaceState}
                            <MortgageRequestSimpleNoteConstructions
                                immEstates={immEstates}
                                showTitle={otherEstatesTitle}
                            />
                            <MortgageRequestSimpleNoteRequestCostWafer
                                immEstates={immEstates}
                                simpleNoteCost={simpleNoteCost}
                                isClientWithoutAccounts={isClientWithoutAccounts}
                                summaryDocumentation={summaryDocumentation}
                            />
                            <div className="mortgage-request-simple-note-payment-view__disclaimer-important">
                                <OKMessage type="important">
                                    <FormattedText value={'mortgageRequestSimpleNotePaymentView-mortgageRequestSimpleNotePaymentView_disclaimerImportant'} />
                                </OKMessage>
                            </div>
                            <div className="mortgage-request-simple-note-payment-view__disclaimer-information-duty">
                                <OKMessage type="informative">
                                    <FormattedText value="mortgageRequestSimpleNotePaymentView-mortgageRequestSimpleNotePaymentView_disclaimerInformationDuty" />
                                </OKMessage>
                            </div>
                            <hr />
                            <div className="mortgage-request-simple-note-payment-view__footer">
                                <a href="#" className="ok-link" onClick={(e) => this.handleOnCancelAddSimpleNote(e)}>
                                    {formatText('common-cancel')}
                                </a>
                                <OKButton
                                    onClick={() => this.handleContinueButton()}
                                    modifier="primary"
                                >
                                    {formatText('mortgageRequestTVPPayment-paymentButton')}
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </ContentBox>
            )
        }

        return (
            <div className="mortgage-request-simple-note-payment-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.getMappingBreacrumb()}
                                finalTitle={getFinalTitle('mortgageRequestSimpleNote-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-offset-2 col-xs-8">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = MortgageRequestSimpleNotePaymentView;

MortgageRequestSimpleNotePaymentView.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageRequestState: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    requestEstates: PropTypes.func.isRequired,
    requestPayment: PropTypes.func.isRequired,
    summaryDocumentation: PropTypes.object.isRequired
};

module.exports.MortgageRequestSimpleNotePaymentView = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        immEstates: state.mortgageRequestInmuebles,
        immPayment: state.mortgageRequestPayment,
        summaryDocumentation: state.mortgageRequestSummaryDocumentation,
        immGlobalPosition: state.globalPosition,
    }), {
    requestEstates: estatesAction.requestInmuebles,
    requestPayment: paymentAction.requestPayment,
}
)(withRouter(MortgageRequestSimpleNotePaymentView));
